import { defineMessages } from 'react-intl';

export default defineMessages({
    AcountType: {
        id: 'ml.common.component.MLBankDetailsComponent.Account Type',
        defaultMessage: 'Account Type'
    },
    NameOfAccountHolder: {
        id: 'ml.common.component.MLBankDetailsComponent.Name of Account Holder',
        defaultMessage: 'Name of Account Holder'
    },
    RoutingNumber: {
        id: 'ml.common.component.MLBankDetailsComponent.Routing Number',
        defaultMessage: 'Routing Number'
    },
    AccountNumber: {
        id: 'ml.common.component.MLBankDetailsComponent.Account Number',
        defaultMessage: 'Account Number'
    },
    ConfirmAccountNumber: {
        id: 'ml.common.component.MLBankDetailsComponent.Confirm Account Number',
        defaultMessage: 'Confirm Account Number'
    },
    Nickname: {
        id: 'ml.common.component.MLBankDetailsComponent.Nickname',
        defaultMessage: 'Nickname'
    },
    RoutingNumberHelperText: {
        id: 'ml.common.component.MLBankDetailsComponent.Where do I find my Routing/Account number?',
        defaultMessage: 'Where do I find my Routing/Account number?'
    },
    InvalidBankDetailsTitle: {
        id: 'ml.common.component.MLBankDetailsComponent.Invalid routing number',
        defaultMessage: 'Invalid routing number'
    },
    InvalidBankDetailsMessage: {
        id: 'ml.common.component.MLBankDetailsComponent.Invalid bank details. Please make sure you put in all required fields',
        defaultMessage: 'Invalid bank details. Please make sure you put in all required fields'
    },
    ServiceErrorTitle: {
        id: 'ml.common.component.MLBankDetailsComponent.Service error',
        defaultMessage: 'Service error'
    },
    ServiceErrorMessage: {
        id: 'ml.common.component.MLBankDetailsComponent.We are unable to validate your routing number. Please try again later',
        defaultMessage: 'We are unable to validate your routing number. Please try again later'
    },
    RoutingNumberTooltipContent: {
        id: 'ml.common.component.MLBankDetailsComponent.Routing Number Tooltip Content',
        defaultMessage: 'Savings account number is on bank statement.  Contact financial institution for routing number.'
    }
});
